import {Component} from '@angular/core';

@Component({
    selector: 'nirby-routes',
    templateUrl: './routes.component.html',
    styleUrls: ['./routes.component.scss'],
})
export class RoutesComponent {
}
